import axios from 'axios';

import { adaptSummaryFilters } from './adapters/filterAdapters';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when fetching monitoring CSA Summaries.');

// eslint-disable-next-line import/prefer-default-export
export const imMonitoringSummaries = (filters = []) => {
    const filterObject = adaptSummaryFilters(filters);

    if (filterObject.runStartDate || filterObject.runEndDate) {
        return axios.post(
            '/CsaMonitor/CsaSummariesSelect',
            {
                ...filterObject,
                counterparty: filterObject.counterparty.map(btoa),
                csa: filterObject.csa || []
            }
        )
            .then(r => r.data).catch(errorHandler);
    }
    throw Error('A date filter is required');
};
